document.addEventListener('DOMContentLoaded', () => {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`));
    if (orders) {
        renderOrderList();
        renderTotalQuantity();
    }
});
function handleOrderVisibility() {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`));
    const orderEmptyText = document.querySelector('.build-your-pack-order__order-empty');
    const orderList = document.querySelector('.build-your-pack-order__order-list');

    if (orders && orders.length > 0) {
        orderList.classList.remove('hidden');
        orderEmptyText.classList.add('hidden');
    } else {
        orderList.classList.add('hidden');
        orderEmptyText.classList.remove('hidden');
    }
}

function renderOrderList() {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];
    const orderListContainer = document.querySelector('.build-your-pack-order__order-list__list');
    orderListContainer.innerHTML = '';

    orders.forEach((product) => {
        const productElement = document.createElement('div');
        productElement.classList.add('build-your-pack-order__order-list__product');

        // Quantity container
        const quantityContainer = document.createElement('div');
        quantityContainer.classList.add('quantityContainer');

        // SVG Icon minus
        const iconMinusElement = document.createElement('span');
        iconMinusElement.classList.add('quantity-icon');
        const iconMinus = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        iconMinus.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        iconMinus.setAttribute('aria-hidden', 'true');
        iconMinus.setAttribute('focusable', 'false');
        iconMinus.setAttribute('class', 'icon icon-minus');
        iconMinus.setAttribute('fill', 'none');
        iconMinus.setAttribute('viewBox', '0 0 10 2');

        const pathElementMinus = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        pathElementMinus.setAttribute('fill-rule', 'evenodd');
        pathElementMinus.setAttribute('clip-rule', 'evenodd');
        pathElementMinus.setAttribute('d', 'M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z');
        pathElementMinus.setAttribute('fill', 'currentColor');

        iconMinus.appendChild(pathElementMinus);
        // Add click event to minus icon
        iconMinusElement.onclick = function () {
            addToOrderQuantity(product.id, -1);
        };

        // Quantity
        const quantityElement = document.createElement('span');
        quantityElement.textContent = `${product.quantity}x`;
        quantityElement.setAttribute('data-variant-id', product.id);
        quantityElement.classList.add('product-quantity');

        const iconPlusElement = document.createElement('span');
        iconPlusElement.classList.add('price-icon');
        // SVG Icon plus
        const iconPlus = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        iconPlus.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        iconPlus.setAttribute('aria-hidden', 'true');
        iconPlus.setAttribute('focusable', 'false');
        iconPlus.setAttribute('class', 'icon icon-plus');
        iconPlus.setAttribute('fill', 'none');
        iconPlus.setAttribute('viewBox', '0 0 10 10');

        const pathElementPlus = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        pathElementPlus.setAttribute('fill-rule', 'evenodd');
        pathElementPlus.setAttribute('clip-rule', 'evenodd');
        pathElementPlus.setAttribute(
            'd',
            'M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1'
        );
        pathElementPlus.setAttribute('fill', 'currentColor');

        iconPlus.appendChild(pathElementPlus);
        // Add click event to plus icon
        iconPlusElement.onclick = function () {
            addToOrderQuantity(product.id, 1);
        };

        // Product info container
        const productInfoContainer = document.createElement('div');
        productInfoContainer.classList.add('productInfoContainer');
        //Product title
        const productTitleElement = document.createElement('span');
        productTitleElement.textContent = product.title;
        productTitleElement.classList.add('product-title');
        // Variant title
        const variantTitleElement = document.createElement('span');
        variantTitleElement.textContent = product.variantTitle;
        variantTitleElement.classList.add('variant-title');

        // Price container
        const priceContainer = document.createElement('div');
        priceContainer.classList.add('priceContainer');

        // Price
        const priceElement = document.createElement('span');
        priceElement.textContent = product.price;
        priceElement.classList.add('product-price');

        iconMinusElement.appendChild(iconMinus);
        quantityContainer.appendChild(iconMinusElement);
        quantityContainer.appendChild(quantityElement);
        productInfoContainer.appendChild(productTitleElement);
        productInfoContainer.appendChild(variantTitleElement);
        iconPlusElement.appendChild(iconPlus);
        priceContainer.appendChild(iconPlusElement);
        priceContainer.appendChild(priceElement);

        productElement.appendChild(quantityContainer);
        productElement.appendChild(productInfoContainer);
        productElement.appendChild(priceContainer);

        orderListContainer.appendChild(productElement);
    });

    const addToCartContainer = document.querySelector('.build-your-pack-order__order-list__add-to-cart-container');
    if (orders.length >= 4) {
        addToCartContainer.style.boxShadow = '0px -1px 2px 0px #00000026';
    } else {
        addToCartContainer.style.boxShadow = '0px 0px 0px 0px transparent';
    }

    const totalPrice = calculateTotalPrice();

    // Actualiza el elemento HTML con el precio total
    let totalPriceElement = '';
    if (window.matchMedia("(max-width: 768px)").matches) {
        // mobile
        totalPriceElement = document.querySelector('.mobile-build-your-pack-order__order-list__total-price');
    } else {
        // desktop
        totalPriceElement = document.querySelector('.build-your-pack-order__order-list__total-price')
    }
    totalPriceElement.textContent = `${totalPrice}€`;

    handleOrderVisibility();
}

function calculateTotalPrice() {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];
    let totalPrice = 0;

    orders.forEach((product) => {
        totalPrice += product.priceWithoutCurrency * product.quantity;
    });
    return (totalPrice / 100).toFixed(2).replace('.', ',');
}

function addToOrderQuantity(variantId, quantityChange, dropdownIdCollection) {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    let orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];

    // Find if product already exists into localStorage.
    const existingProductIndex = orders.findIndex((item) => item.id === variantId);

    if (existingProductIndex !== -1) {
        orders[existingProductIndex].quantity += quantityChange;
        if (orders[existingProductIndex].quantity < 1) {
            // Remove product from orders if quantity is 0
            orders.splice(existingProductIndex, 1);
            const dropdownId = `${dropdownIdCollection}`;
            const dropdown = document.getElementById(dropdownId);
            if (dropdown) {
                dropdown.style.display = 'none';
            }
            setTimeout(() => {
                renderTotalQuantity();
            }, 100)

        } else {
            localStorage.setItem(`orders-${urlPathname}`, JSON.stringify(orders));

            renderOrderList();

            // Get dropdown ID on mobile
            const dropdownId = `${dropdownIdCollection}`;
            const dropdown = document.getElementById(dropdownId);

            if (dropdown) {
                const quantityElement = dropdown.querySelector('.product-quantity');
                quantityElement.innerText = `${orders[existingProductIndex].quantity}x`;

                const priceElement = dropdown.querySelector('.product-price');
                const totalPrice = orders[existingProductIndex].priceWithoutCurrency * orders[existingProductIndex].quantity;
                const formattedPrice = (totalPrice / 100).toFixed(2).replace('.', ',');
                priceElement.innerText = `${formattedPrice}€`;


            }
            renderTotalQuantity();
            return; // Exit the function early if quantity is updated but not 0
        }

    }

    localStorage.setItem(`orders-${urlPathname}`, JSON.stringify(orders));

    renderOrderList();
}

function addToOrder(event) {
    const variantId = event.target
        .closest('.build-your-pack__collection-product__product-card')
        .getAttribute('data-variant-id');

    const productTitle = event.target
        .closest('.build-your-pack__collection-product__product-card')
        .getAttribute('data-product-title');

    const productVariantTitle = event.target
        .closest('.build-your-pack__collection-product__product-card')
        .getAttribute('data-variant-title');

    const price = event.target.closest('.build-your-pack__collection-product__product-card').getAttribute('data-price');

    const priceWithoutCurrency = event.target
        .closest('.build-your-pack__collection-product__product-card')
        .getAttribute('data-price-without-currency');

    const productInfo = {
        id: variantId,
        title: productTitle,
        variantTitle: productVariantTitle,
        price: price,
        priceWithoutCurrency: priceWithoutCurrency,
        quantity: 1,
    };
    const urlPathname = window.location.pathname.split('/pages/')[1];

    let orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];

    // Find if product already exists into localStorage.
    const existingProductIndex = orders.findIndex((item) => item.id === variantId);

    if (existingProductIndex !== -1) {
        orders[existingProductIndex].quantity += 1;
    } else {
        orders.push(productInfo);
    }
    localStorage.setItem(`orders-${urlPathname}`, JSON.stringify(orders));

    setTimeout(() => {
        renderTotalQuantity();
    }, 100)
    renderOrderList();
}

function addOrderToCart() {
    // Obtener el array de productos del localStorage
    const urlPathname = window.location.pathname.split('/pages/')[1];

    const products = JSON.parse(localStorage.getItem(`orders-${urlPathname}`));

    if (!products || products.length === 0) {
        console.error('No hay productos en el carrito.');
        return;
    }

    try {
        const reversedProducts = products.reverse();

        const items = reversedProducts.map((product) => {
            const { id, quantity } = product;
            return { id, quantity };
        });

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const formData = {
            items,
            sections: cart.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error al agregar producto al carrito');
                }
                return response.json();
            })
            .then((data) => {
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                    .then((response) => response.text())
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        const sourceQty = html.querySelector('.drawer__inner');
                        document.querySelector('cart-drawer').classList.remove('is-empty');
                        document.querySelector('.drawer__inner').innerHTML = sourceQty.innerHTML;
                        if (localStorage.getItem('__ui')) localStorage.removeItem('__ui');

                        const cartBubble = document.querySelector('.cart-count-bubble');
                        if (cartBubble != undefined) {

                            cartBubble.classList.remove('hidden');
                            const totalQuantity = data.items.reduce((total, item) => {
                                return total + item.quantity;
                            }, 0);
                            cartBubble.querySelector('span[aria-hidden="true"]').innerText = totalQuantity;
                        } else {
                            const cartItemContainer = document.querySelector('#cart-icon-bubble');

                            const customElementBubble = document.createElement('div');
                            customElementBubble.classList.add('cart-count-bubble');
                            const totalQuantity = data.items.reduce((total, item) => {
                                return total + item.quantity;
                            }, 0);

                            customElementBubble.innerHTML = `<span aria-hidden="true">${totalQuantity}</span>`;

                            cartItemContainer.appendChild(customElementBubble)
                        }
                        cart.open();
                        // Clean localStorage after user add items to cart.
                        const urlPathname = window.location.pathname.split('/pages/')[1];
                        localStorage.removeItem(`orders-${urlPathname}`);

                        const allDropdowns = document.querySelectorAll('.mobile-build-your-pack-order__order-list__product');

                        allDropdowns.forEach((dropdown) => {
                            if (dropdown.parentNode.style.display == 'block') {
                                dropdown.parentNode.style.display = 'none';
                            }
                        })

                        renderOrderList();
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    } catch (error) {
        console.error('Error:', error);
    }
}

// Se abre el dropdown cuando recargas la página sólo del producto que ya exista en el localStorage
function openDropdownsForExistingProducts() {
    const dropdowns = document.querySelectorAll('.dropdown');
    const urlPathname = window.location.pathname.split('/pages/')[1];
    const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];

    dropdowns.forEach((dropdown) => {
        const variantId = dropdown.getAttribute('data-dropdown-variant-id');
        const foundProduct = orders.find((order) => order.id === variantId);

        if (foundProduct) {
            dropdown.style.display = 'block';

            const quantity = dropdown.querySelector('.product-quantity');
            const productTitle = dropdown.querySelector('.product-title');
            const variantTitle = dropdown.querySelector('.variant-title');
            const price = dropdown.querySelector('.product-price');

            quantity.innerText = `${foundProduct.quantity}x`;
            productTitle.innerText = foundProduct.title;
            variantTitle.innerText = foundProduct.variantTitle;
            price.innerText = `${((foundProduct.priceWithoutCurrency * foundProduct.quantity) / 100)
                .toFixed(2)
                .replace('.', ',')}€`;
        }
    });
}

document.addEventListener('DOMContentLoaded', openDropdownsForExistingProducts);

// Se abre el dropdown cuando pulsas sobre el + y puedes quitar o sumar cantidades.
function toggleDropdown(event, dropdownId) {
    var dropdown = document.getElementById(dropdownId);

    if (dropdown.style.display === 'none') {
        dropdown.style.display = 'block';

        addToOrder(event);
        const getVariantId = event.target
            .closest('.build-your-pack__collection-product__product-card')
            .getAttribute('data-variant-id');
        const urlPathname = window.location.pathname.split('/pages/')[1];
        const orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];

        const foundProduct = orders.find((order) => order.id === getVariantId);

        if (foundProduct) {

            const quantity = dropdown.querySelector('.product-quantity');
            quantity.innerText = `${foundProduct.quantity}x`;

            const productTitle = dropdown.querySelector('.product-title');
            productTitle.innerText = foundProduct.title;

            const variantTitle = dropdown.querySelector('.variant-title');
            variantTitle.innerText = foundProduct.variantTitle;

            const price = dropdown.querySelector('.product-price');
            const totalPrice = foundProduct.priceWithoutCurrency * foundProduct.quantity;
            price.innerText = `${(totalPrice / 100).toFixed(2).replace('.', ',')}€`;

            renderTotalQuantity();

        } else {
            console.log('Elemento no encontrado para el variantId:', getVariantId);
        }
    }
}

function renderTotalQuantity() {
    const urlPathname = window.location.pathname.split('/pages/')[1];
    let orders = JSON.parse(localStorage.getItem(`orders-${urlPathname}`)) || [];
    let totalQuantity = 0;

    orders.forEach((item) => {
        totalQuantity += item.quantity;
    });

    let totalQuantityElement = '';
    if (window.matchMedia("(max-width: 768px)").matches) {
        // mobile
        totalQuantityElement = document.querySelector('.mobile-items-totals');
    } else {
        // desktop
        totalQuantityElement = document.querySelector('.items-totals')
    }

    if (totalQuantityElement) {

        if (totalQuantity == 0) {
            totalQuantityElement.parentNode.parentNode.classList.add('hidden');
        } else {
            totalQuantityElement.parentNode.parentNode.classList.remove('hidden');
            totalQuantityElement.innerText = totalQuantity == 1 ? `${totalQuantity.toString()} unidad` : `${totalQuantity.toString()} unidades`;
        }

    }
}
